<template>
  <div class="folder-item" @contextmenu.stop="clickMore(info)">
    <!-- 公有标签 -->
    <div v-if="info.fileFolder.publicFlag === 1" class="public-tag">公共</div>

    <div>
      <div class="imgBox" :style="backgroundStyle" :id="info.fileFolder.folderId"></div>
    </div>
    <div class="text-content">
      <div class="title" :title="info.fileFolder.folderName">{{ info.fileFolder.folderName }}</div>
      <div class="title time" :title="info.fileFolder.createDate">{{ info.fileFolder.createDate }}</div>
    </div>
    <div class="more" title="更多" v-if="has('addFileButton') || canOperateAllOf(info)">
      <el-dropdown trigger="click">
        <i class="el-icon-more" @click.stop="clickMore(info)"></i>
        <fileTab ref="rightTab" @ok="refresh"></fileTab>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: "folderBox",
  components: {
    'fileTab': () => import('@/components/file/fileTab.vue'),
  },
  props: {
    info: Object,
  },
  data() {
    return {
      backgroundStyle: {
        backgroundImage: `url(${require('@/assets/file/wjj.png')})`,
        width: "25px",
        height: "25px",
        backgroundSize: 'cover', // 适应容器大小
        backgroundPosition: 'center' // 居中对齐
      }
    }
  },
  methods: {
    refresh() {
      this.$emit("ok");
    },
    clickMore(info) {
      event.preventDefault();
      this.$refs.rightTab.openDia(info);

    },
    /**
     * 提取目标资源的 canOperateAll 数据权限（兼容顶层与嵌套结构）
     * @param {Object} target - 文件/文件夹列表项
     * @returns {boolean}
     */
    canOperateAllOf(target) {
      if (!target) return false;
      const op =
        target.operationPermission ||
        (target.fileInfo && target.fileInfo.operationPermission) ||
        (target.fileFolder && target.fileFolder.operationPermission);
      return !!(op && op.canOperateAll);
    },

  }
}
</script>


<style scoped lang="scss">
.folder-item {
  width: 100%;
  /* 改为100%，跟随父容器宽度 */
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  padding: 10px 4px 10px 12px;

  .public-tag {
    position: absolute;
    top: 15px;
    left: 12px;
    background: linear-gradient(135deg, #ffd89b 0%, #f9a825 100%);
    color: #fff;
    font-size: 7px;
    padding: 1px 2px 1px 1px;
    border-radius: 0 0 8px 0;
    font-weight: 500;
    box-shadow: 0 2px 4px rgba(249, 168, 37, 0.3);
    z-index: 10;
    line-height: 1.4;
  }

  .text-content {
    flex: 1;
    min-width: 0;
    /* 关键：允许flex子元素收缩到内容宽度以下 */
    margin: 0 10px;
  }


  .more {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease;
  }


  .title {
    color: #363b4c;
    z-index: 900;
    width: 100%;
    font-size: 14px;
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏超出内容 */
    text-overflow: ellipsis;
    /* 使用省略号替代被隐藏的文本 */
  }

  .time {
    color: #6f7588;
    font-size: 12px;
  }

  .imgBox {
    flex-shrink: 0;
    /* 防止图标被压缩 */
    width: 25px;
    height: 25px;

    .fileType {
      top: 0;
      left: 0;
      font-size: 18px;
    }
  }
}

.folder-item:hover {
  background-color: #ddeaff;
  border-radius: 4px;

  .more {
    opacity: 1;
    visibility: visible;
  }
}
</style>